import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiShare2,FiHeart,FiMessageCircle,FiTrendingUp,FiUsers,FiEye,FiChevronLeft,FiChevronRight}=FiIcons;

const SocialMediaImpact=()=> {
const [showRealPosts,setShowRealPosts]=useState(false);
const [currentPostIndex,setCurrentPostIndex]=useState(0);

const socialQuotes=[ 
"Excellent insights on AI applications in actuarial work",
"Great summit covering the future of our profession",
"Highly recommend for any actuary interested in AI" 
];

const realLinkedInPosts=[ 
{id: 1,author: 'Zhixin Wu',title: 'PhD & MAAA,Professor of Business Analytics',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212658247-image.png',description: 'Professor expressing gratitude for the AI Actuary Virtual Summit'},
{id: 2,author: 'Mary Pat Campbell',title: 'Insurance Industry Researcher at Conning',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212662848-image.png',description: 'Industry researcher highlighting summit content and sessions'},
{id: 3,author: 'Joyce Kasyoka',title: 'Data Analytics | Actuarial | Insurance',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212667004-image.png',description: 'Data analyst discussing AI automation impacts from the summit'},
{id: 4,author: 'Titus Maina',title: 'Aspiring P&C Actuary | CAS Student Member',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212671725-image.png',description: 'Actuarial student sharing insights on AI evolution in the profession'},
{id: 5,author: 'Osunbiyi,Yusuf Olatunji',title: 'Risk Management and Insurance Professional',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212907780-image.png',description: 'Risk management professional promoting the AI Summit registration'},
{id: 6,author: 'Khayrul Alam',title: 'Actuarial Consultant',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212939624-image.png',description: 'Industry professional expressing excitement about attending the summit'},
{id: 7,author: 'Brad Paulis',title: 'Partner,Continuing Care Actuaries',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212946034-image.png',description: 'Senior partner excited to attend the AI conference'},
{id: 8,author: 'Patrick John Lee',title: 'Founder of inqa.group,Software Architect',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212950532-image.png',description: 'Actuarial organization founder praising the summit concept'},
{id: 9,author: 'Debbie Barker',title: 'Senior Actuarial Manager at Capita Life & Pensions',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758212954790-image.png',description: 'Senior actuarial manager looking forward to the packed schedule of talks'},
{id: 11,author: 'Maimouna (Mai) Coulibaly',title: 'Professional Storyteller',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758213351716-image.png',description: 'Professional promoting the AI Actuary Virtual Summit registration'},
{id: 13,author: 'Syed Faizan Haider,ASA',title: 'Actuarial Consultant | 6+ Years Experience',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758213394826-image.png',description: 'ASA consultant excited about AI transformation in actuarial science'},
{id: 15,author: 'Cathy Lyn FIA FSA',title: 'Founder,Diversity of Thought Series',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758213544678-image.png',description: 'FIA FSA founder endorsing the AI Actuary Virtual Summit with detailed speaker lineup'},
{id: 17,author: 'Khanh Bui',title: 'ASA | Actuarial Pricing | Reinsurance Management',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758213609983-image.png',description: 'ASA sharing exclusive AI Actuary Virtual Summit opportunity with detailed session info'},
{id: 18,author: 'Michael Clark',title: 'Actuary & Investment Consultant | Writer & Speaker',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758213616014-image.png',description: 'Actuary and consultant excited for virtual summit on AI applications in actuarial work'},
{id: 19,author: 'Aayush Sancheti',title: 'FRM | Investment Actuary',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758213620750-image.png',description: 'Investment Actuary looking forward to AI discussions and career pathway insights'},
{id: 20,author: 'ProActuary Official Post',title: 'The AI Actuary Virtual Summit - Empowering Actuaries with AI',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758213873828-image.png',description: 'Official ProActuary summit announcement with sponsor logos and 20,295 impressions showing massive reach'},
{id: 21,author: 'Moyege Oke',title: 'Bsc. Actuarial Science Student at Bayes Business School,City,University of London',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758269824789-image.png',description: 'Actuarial science student excited about attending AI Actuary 2025 and understanding AI incorporation in the industry'},
{id: 22,author: 'Arjun Sachin Nair',title: 'Aspiring Actuary | IAI Student Member | UCSD Applied Mathematics & Data Science',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758269829886-image.png',description: 'IAI student member thrilled to attend ProActuary Summit 2025,exploring AI transformation in actuarial practice'},
{id: 23,author: 'David Scholl',title: 'Manager & Product Actuary at Central States Health & Life Co. of Omaha',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758269839510-image.png',description: 'Product actuary sharing information about interesting AI talks from ProActuary.com coming up next week'},
{id: 24,author: 'Linhui D.',title: 'Leader | Innovator | Venturer | Advisor | Data,Analytics & AI Expert',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758269885893-image.png',description: 'Data and AI expert looking forward to the nice agenda and thanking ProActuary.com'},
{id: 25,author: 'Miriam Arribas Garcia',title: 'Pricing Actuary at Mapfre',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758269894964-image.png',description: 'Pricing actuary recommending AI talks for actuaries from ProActuary.com'},
{id: 26,author: 'Georges Allam,CERA,ASA,FCAA,FCA',title: 'Senior Actuarial Consultant at ACTROPY LTD Generosity towards...',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270451154-image.png',description: 'Senior certified actuarial consultant finding the AI event interesting for exploring practical applications'},
{id: 27,author: 'Douglas Van Dam',title: 'Principal Consultant at Van Dam Consulting Group',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270461033-image.png',description: 'Principal consultant looking forward to the ProActuary virtual summit'},
{id: 28,author: 'Rong Rong,FSA,CERA,CPCU',title: 'Always learning~',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270466298-image.png',description: 'FSA certified actuary excited to learn about latest AI use cases from ProActuary.com'},
{id: 29,author: 'Aisha Faleeldeen,FCA,ASA,MAAA',title: 'Experienced Risk Manager and Actuary recognized for implementation...',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270471735-image.png',description: 'Experienced risk manager promoting the free AI summit registration sponsored by ProActuary.com'},
{id: 30,author: 'Andrew Spinelli',title: 'Analytics and Actuarial Services',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270476415-image.png',description: 'Analytics professional interested in the free virtual summit with global perspective on AI in actuarial work from ProActuary.com'},
{id: 31,author: 'ProActuary.com',title: '9,036 followers - AI Actuary Virtual Summit 2025 Announcement',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270582368-image.png',description: 'ProActuary official announcement of AI Actuary Virtual Summit 2025 with sponsor branding and registration link'},
{id: 32,author: 'Jian Yu',title: 'Retired CFO and Chief Actuary,Healthcare Executive,Board Member',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270680352-image.png',description: 'Senior healthcare executive thanking ProActuary for hosting the summit with official event branding visible'},
{id: 33,author: 'Jody Koenemann',title: 'SVP and Actuary,Assumptions at Fortitude Re',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270759085-image.png',description: 'Senior Vice President and Actuary looking forward to attending the 2025 AI Actuary Virtual Summit hosted by ProActuary.com'},
{id: 34,author: 'Khanh Bui (Duplicate Entry)',title: 'ASA | Actuarial Pricing | Reinsurance Management | IFRS 17',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270768080-image.png',description: 'ASA professional excited to share the exclusive AI Actuary Virtual Summit opportunity with detailed event information'},
{id: 35,author: 'AInsurCo',title: '16,433 followers - The Rise of Actuarial Engineers',image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758270820407-image.png',description: 'Insurance company with 16K+ followers discussing actuarial engineers and referencing THE AI Actuary Event organized by ProActuary.com'}
];

const viralImpactPoints=[ 
'Authentic Endorsements: Real attendees genuinely recommending the event',
'Trusted Sources: Professional peers carry more weight than advertising',
'Extended Reach: Each share exposes your brand to new networks',
'Lasting Impact: Social posts remain visible long after the event' 
];

const nextPost=()=> {
setCurrentPostIndex((prev)=> (prev + 1) % realLinkedInPosts.length);
};

const prevPost=()=> {
setCurrentPostIndex((prev)=> (prev - 1 + realLinkedInPosts.length) % realLinkedInPosts.length);
};

return ( 
<motion.div className="space-y-8" initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6}} > 
{/* Main Social Impact Section */} 
<div className="glass-effect rounded-2xl p-8"> 
<div className="text-center mb-8"> 
<motion.h2 className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center" initial={{opacity: 0}} animate={{opacity: 1}} transition={{delay: 0.2}} > 
<SafeIcon icon={FiShare2} className="text-purple-400 mr-3" /> 
Social Media Viral Impact 
</motion.h2> 
<div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full" /> 
</div> 

<div className="bg-gradient-to-br from-purple-600/30 to-pink-600/30 rounded-xl p-6 mb-8"> 
<h3 className="text-2xl font-bold text-white mb-6 flex items-center"> 
<SafeIcon icon={FiTrendingUp} className="text-purple-400 mr-3" /> 
Organic Social Sharing 
</h3> 
<p className="text-white/90 leading-relaxed"> 
Attendees organically shared the event across LinkedIn,X,and other platforms,creating authentic endorsements and expanding your brand reach beyond the initial audience. 
</p> 
</div> 

<motion.div className="bg-gradient-to-r from-orange-500/20 to-pink-500/20 rounded-xl p-6 border border-orange-500/30" initial={{opacity: 0,scale: 0.95}} animate={{opacity: 1,scale: 1}} transition={{delay: 0.4}} > 
<h3 className="text-xl font-bold text-white mb-3 flex items-center"> 
<SafeIcon icon={FiTrendingUp} className="text-orange-400 mr-2" /> 
Viral Amplification 
</h3> 
<p className="text-white/90 leading-relaxed"> 
Attendees organically shared the event across LinkedIn,X,and other platforms,creating authentic endorsements and expanding your brand reach. 
</p> 
<p className="text-white/90 leading-relaxed mt-2"> 
<strong className="text-orange-300">Key Insight:</strong> Social shares included sponsor branding and created trusted peer-to-peer recommendations. 
</p> 
</motion.div> 
</div> 

{/* Viral Social Shares Showcase */} 
<div className="glass-effect rounded-2xl p-8"> 
<div className="text-center mb-8"> 
<motion.h2 className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center" initial={{opacity: 0}} animate={{opacity: 1}} transition={{delay: 0.2}} > 
<SafeIcon icon={FiHeart} className="text-pink-400 mr-3" /> 
Viral Social Media Shares - Organic Endorsements 
</motion.h2> 
<div className="w-24 h-1 bg-gradient-to-r from-pink-500 to-purple-500 mx-auto rounded-full" /> 
</div> 

<motion.div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-xl p-6 mb-8 border border-blue-500/30" initial={{opacity: 0,scale: 0.95}} animate={{opacity: 1,scale: 1}} transition={{delay: 0.3}} > 
<h3 className="text-xl font-bold text-white mb-3 flex items-center"> 
<SafeIcon icon={FiUsers} className="text-blue-400 mr-2" /> 
Authentic Peer-to-Peer Recommendations 
</h3> 
<p className="text-white/90 leading-relaxed"> 
Over <span className="font-bold text-blue-300">50+ organic social media shares</span> by attendees created trusted endorsements and expanded your brand reach. These authentic posts included sponsor branding and generated thousands of additional impressions. 
</p> 
</motion.div> 

<div className="bg-gradient-to-br from-blue-600/30 to-purple-600/30 rounded-xl p-6 mb-8"> 
<div className="text-center mb-6"> 
<h3 className="text-2xl font-bold text-white mb-4 flex items-center justify-center"> 
<SafeIcon icon={FiMessageCircle} className="text-blue-400 mr-3" /> 
Sample LinkedIn Shares 
</h3> 
</div> 

{/* Sample Quotes Grid */} 
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6"> 
{socialQuotes.map((quote,index)=> ( 
<motion.div key={index} className="glass-effect rounded-lg p-4 border border-white/10 hover:border-white/30 transition-colors" initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: 0.4 + index * 0.1}} > 
<p className="text-white/90 italic text-center">"{quote}"</p> 
</motion.div> 
))} 
</div> 

{/* View Real Posts Button */} 
<div className="text-center mb-6"> 
<motion.button onClick={()=> setShowRealPosts(!showRealPosts)} className="inline-flex items-center space-x-3 bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300" whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} > 
<SafeIcon icon={FiEye} className="text-xl" /> 
<span>{showRealPosts ? 'Hide Real LinkedIn Posts' : 'View Real LinkedIn Posts'}</span> 
</motion.button> 
</div> 

{/* Real LinkedIn Posts Carousel */} 
<AnimatePresence> 
{showRealPosts && ( 
<motion.div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-xl p-6 border border-blue-500/30" initial={{opacity: 0,height: 0}} animate={{opacity: 1,height: 'auto'}} exit={{opacity: 0,height: 0}} transition={{duration: 0.5}} > 
<h4 className="text-xl font-bold text-white mb-4 text-center flex items-center justify-center"> 
<SafeIcon icon={FiMessageCircle} className="text-blue-400 mr-2" /> 
Real LinkedIn Posts from Attendees ({realLinkedInPosts.length} Total) 
</h4> 

<div className="relative"> 
<div className="flex items-center justify-between mb-4"> 
<motion.button onClick={prevPost} className="p-2 bg-blue-500/20 hover:bg-blue-500/40 rounded-lg transition-colors" whileHover={{scale: 1.1}} whileTap={{scale: 0.9}} > 
<SafeIcon icon={FiChevronLeft} className="text-blue-400 text-xl" /> 
</motion.button> 

<div className="text-center"> 
<span className="text-white/70 text-sm"> 
{currentPostIndex + 1} of {realLinkedInPosts.length} 
</span> 
</div> 

<motion.button onClick={nextPost} className="p-2 bg-blue-500/20 hover:bg-blue-500/40 rounded-lg transition-colors" whileHover={{scale: 1.1}} whileTap={{scale: 0.9}} > 
<SafeIcon icon={FiChevronRight} className="text-blue-400 text-xl" /> 
</motion.button> 
</div> 

<AnimatePresence mode="wait"> 
<motion.div key={currentPostIndex} className="text-center" initial={{opacity: 0,x: 100}} animate={{opacity: 1,x: 0}} exit={{opacity: 0,x: -100}} transition={{duration: 0.3}} > 
<div className="mb-3"> 
<h5 className="text-lg font-semibold text-white"> 
{realLinkedInPosts[currentPostIndex].author} 
</h5> 
<p className="text-sm text-white/70"> 
{realLinkedInPosts[currentPostIndex].title} 
</p> 
</div> 

<div className="max-w-2xl mx-auto"> 
<img src={realLinkedInPosts[currentPostIndex].image} alt={realLinkedInPosts[currentPostIndex].description} className="w-full h-auto rounded-lg border border-white/20 shadow-lg" /> 
</div> 

<p className="text-sm text-white/70 mt-3"> 
{realLinkedInPosts[currentPostIndex].description} 
</p> 
</motion.div> 
</AnimatePresence> 

{/* Dot indicators */} 
<div className="flex justify-center space-x-2 mt-4 flex-wrap"> 
{realLinkedInPosts.map((_,index)=> ( 
<button key={index} onClick={()=> setCurrentPostIndex(index)} className={`w-2 h-2 rounded-full transition-colors mb-1 ${index===currentPostIndex ? 'bg-blue-400' : 'bg-white/30'}`} /> 
))} 
</div> 
</div> 
</motion.div> 
)} 
</AnimatePresence> 
</div> 

<motion.div className="bg-gradient-to-r from-green-500/20 to-blue-500/20 rounded-xl p-6 border border-green-500/30" initial={{opacity: 0,scale: 0.95}} animate={{opacity: 1,scale: 1}} transition={{delay: 0.8}} > 
<h3 className="text-xl font-bold text-white mb-4 flex items-center"> 
<SafeIcon icon={FiTrendingUp} className="text-green-400 mr-2" /> 
Why This Matters for Sponsors 
</h3> 
<div className="space-y-3"> 
{viralImpactPoints.map((point,index)=> ( 
<motion.div key={index} className="flex items-start space-x-3" initial={{opacity: 0,x: -20}} animate={{opacity: 1,x: 0}} transition={{delay: 0.9 + index * 0.1}} > 
<div className="w-2 h-2 bg-green-400 rounded-full mt-3 flex-shrink-0" /> 
<p className="text-white/90 leading-relaxed">{point}</p> 
</motion.div> 
))} 
</div> 
</motion.div> 
</div> 
</motion.div> 
);
};

export default SocialMediaImpact;